
  function initTestimonials20() {
      document.querySelector('.pc-testimonials-slider-template--24766391910738__pc_social_review_5_zdAqzC').classList.remove('preview');
      new Swiper(".pc-testimonials-slider-template--24766391910738__pc_social_review_5_zdAqzC", {
          speed: 2500,
          
          loop: true,
          
          
          navigation: {
              nextEl: '.pc-testimonials-btn-next-template--24766391910738__pc_social_review_5_zdAqzC',
              prevEl: '.pc-testimonials-btn-prev-template--24766391910738__pc_social_review_5_zdAqzC',
          },
          pagination: {
              el: '.pc-testimonials-pagination-template--24766391910738__pc_social_review_5_zdAqzC',
              type: "bullets",
              clickable: true
          },
          breakpoints: {
              320: {
                  spaceBetween: 24,
                  slidesPerView: 1.3,
              },
              768: {
                  spaceBetween: 24,
                  slidesPerView: 1.5,
              },
              1024: {
                  spaceBetween: 32,
                  slidesPerView: 3,
              }
          }
      });
  }

  document.addEventListener('DOMContentLoaded', initTestimonials20);
